import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export function DuplicateAccountsFilters() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchInput, setSearchInput] = useState(
    searchParams.get("search") || ""
  );

  const hasActiveFilters = !!searchParams.get("search");

  const commitSearch = () => {
    const params = new URLSearchParams(searchParams);
    if (searchInput.trim()) {
      params.set("search", searchInput.trim());
    } else {
      params.delete("search");
    }
    params.set("page", "0");
    setSearchParams(params);
  };

  const handleReset = () => {
    setSearchInput("");
    const params = new URLSearchParams();
    params.set("page", "0");
    setSearchParams(params);
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="flex items-center gap-1">
        <div className="relative">
          <Input
            placeholder="name: / phone: / email: / or free text"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && commitSearch()}
            className="w-72 h-9 text-sm"
          />
        </div>
        <Button
          type="button"
          variant="outline"
          size="icon"
          className="h-9 w-9 shrink-0"
          onClick={commitSearch}
        >
          <Search className="h-4 w-4" />
        </Button>
      </div>

      {hasActiveFilters && (
        <Button variant="outline" size="sm" onClick={handleReset}>
          <X className="h-4 w-4 mr-1" />
          Reset
        </Button>
      )}
    </div>
  );
}
